import { EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
var CourseLearningMainComponent = (function () {
    function CourseLearningMainComponent(route, router, apiService, commonService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.commonService = commonService;
        // @Input() questionIndex: any;
        this.onExit = new EventEmitter();
        this.onGoToQuestion = new EventEmitter();
        this.assetsRoute = "../../assets";
    }
    CourseLearningMainComponent.prototype.onPopState = function () {
        if (this.timeCheck) {
            clearInterval(this.timeCheck);
        }
    };
    CourseLearningMainComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.log('video:' + this.pathName);
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        setTimeout(function () {
            _this.isShowLoadingComponent = true;
        }, 5000);
        var that = this;
        this.timeCheck = null;
        var runTime = 0, totalTime = 0;
        this.timeCheck = setInterval(function () {
            if (that.player) {
                totalTime = that.player.j2s_getDuration() * 0.95;
                runTime = that.player.j2s_getCurrentTime();
                // console.log("runTime is" + runTime.toString());
                // console.log("totalTime is" + totalTime.toString());
                if (runTime >= totalTime && totalTime > 0) {
                    // that.apiService.finishLesson("" + that.lesson.id + "", "" + this.videoIndex + "").subscribe(lesson => {});
                    that.apiService.finishLesson("" + that.lesson.id + "", "" + that.lesson.externalId[that.videoIndex] + "").subscribe(function (lesson) {
                        if (that.lesson.status != 2) {
                            if (that.lesson.hasMultiLesson && that.videoIndex < that.lesson.externalId.length - 1) {
                                that.lesson.status = 21 + that.videoIndex;
                            }
                            else {
                                that.lesson.status = 2;
                            }
                        }
                    });
                    clearInterval(that.timeCheck);
                }
            }
        }, 500);
        // window['s2j_onPlayerInitOver'] = function(){
        // }
        // window['s2j_onVideoSeek'] = function(){
        //   let totalTime = 0,
        //       runTime = 0;
        //   runTime = that.player.j2s_getCurrentTime();
        //   totalTime = that.player.j2s_getDuration() * 0.95;
        //   if(runTime >= totalTime && totalTime > 0){
        //     // that.apiService.finishLesson("" + that.lesson.id + "", "" + this.videoIndex + "").subscribe(lesson => {});
        //     that.apiService.finishLesson("" + that.lesson.id + "", "" + that.lesson.externalId[that.videoIndex] +"").subscribe(lesson => {});
        //     if(that.timeCheck){
        //       clearInterval(that.timeCheck);
        //     }
        //   }
        // }
        window['s2j_onPlayerInitOver'] = function () {
            that.isShowLoadingComponent = false;
        };
        window['s2j_onPlayOver'] = function () {
            // console.log("finished lesson!");
            // 测试
            var data = { "status": 2 };
            var preLength = 0;
            /*if(that.course.name=='沟通课程'&&that.lessonIndex==that.course.lessons.length-1){
                return;
            }*/
            if (that.lesson.questionsGroup) {
                preLength = that.lesson.questionsGroup.filter(function (q) { return q.afterClass == 2; }).length;
            }
            that.apiService.finishLesson("" + that.lesson.id + "", "" + that.lesson.externalId[that.videoIndex] + "").subscribe(function (lesson) {
                if (that.timeCheck) {
                    clearInterval(that.timeCheck);
                }
                if (that.lesson.status != 2) {
                    if (that.lesson.hasMultiLesson && that.videoIndex < that.lesson.externalId.length - 1) {
                        that.lesson.status = 21 + that.videoIndex;
                    }
                    else {
                        that.lesson.status = 2;
                    }
                    $("#video").hide();
                    if (that.lesson.hasPreLesson && that.lesson.questionsGroup) {
                        if (preLength < that.lesson.questionsGroup.length) {
                            that.onGoToQuestion.emit([that.lessonIndex, preLength]);
                        }
                        else {
                            // that.lesson.questionsGroup = null;
                            that.onGoToQuestion.emit([that.lessonIndex, preLength]);
                        }
                    }
                    else {
                        that.onGoToQuestion.emit([that.lessonIndex, 0]);
                    }
                }
                else {
                    if (that.lesson.hasPreLesson && that.lesson.questionsGroup) {
                        if (preLength < that.lesson.questionsGroup.length) {
                            that.onGoToQuestion.emit([that.lessonIndex, preLength]);
                        }
                        else {
                            // that.lesson.questionsGroup = null;
                            that.onGoToQuestion.emit([that.lessonIndex, preLength]);
                        }
                    }
                    else {
                        that.onGoToQuestion.emit([that.lessonIndex, 0]);
                    }
                }
            });
            // if(that.lesson.status!=2){
            //   // if(that.lesson.hasMultiLesson && that.videoIndex < that.lesson.externalId.length - 1){
            //   //   that.lesson.status = 21 + that.videoIndex;
            //   // } else{
            //   //   that.lesson.status = 2;
            //   // }
            //   if(that.lesson.hasPreLesson && that.lesson.questionsGroup){
            //     if(preLength < that.lesson.questionsGroup.length){
            //       that.onGoToQuestion.emit([that.lessonIndex, preLength]);
            //     }else{
            //       // that.lesson.questionsGroup = null;
            //       that.onGoToQuestion.emit([that.lessonIndex, preLength]);
            //     }
            //   }else{
            //     that.onGoToQuestion.emit([that.lessonIndex, 0]);
            //   }
            // }else{
            //   if(that.lesson.hasPreLesson && that.lesson.questionsGroup){
            //     if(preLength < that.lesson.questionsGroup.length){
            //       that.onGoToQuestion.emit([that.lessonIndex, preLength]);
            //     }else{
            //       // that.lesson.questionsGroup = null;
            //       that.onGoToQuestion.emit([that.lessonIndex, preLength]);
            //     }
            //   }else{
            //     that.onGoToQuestion.emit([that.lessonIndex, 0]);
            //   }
            // }
        };
    };
    CourseLearningMainComponent.prototype.ngOnChanges = function () {
        var height = window.screen.width / 16 * 9;
        var player = polyvPlayer({
            wrap: '#video',
            'width': '100%',
            'height': height,
            'vid': this.lesson.externalId[this.videoIndex],
            'forceH5': true,
        });
        this.player = player;
    };
    CourseLearningMainComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage();
    };
    CourseLearningMainComponent.prototype.close = function () {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        if (this.timeCheck) {
            clearInterval(this.timeCheck);
        }
        if (isAndroid) {
            document.getElementById("tip1").style.marginTop = "0rem";
            var htmlFontSize = window.screen.width / 7.5;
            var top_1 = document.documentElement.offsetHeight - 3.28 * htmlFontSize;
            document.getElementById("tip1").style.top = top_1 + "px";
        }
        if (this.lesson.status == 2) {
            this.exit();
        }
        else {
            $("#shade").fadeIn(300);
            $("#tip1").fadeIn(300);
            this.disableRolling();
        }
    };
    CourseLearningMainComponent.prototype.continue = function () {
        $("#tip1").fadeOut(300);
        $("#shade").fadeOut(300);
    };
    CourseLearningMainComponent.prototype.exit = function () {
        this.onExit.emit(true);
    };
    /*goToQuestion(){
        document.getElementById('picture').style.transform='scale(0)';
        let _this = this;
        setTimeout(function () {
            _this.onGoToQuestion.emit(_this.lessonIndex);
        },1000);
        $('#savePic').fadeOut(1000);
    }*/
    CourseLearningMainComponent.prototype.disableRolling = function () {
        document.getElementById('shade').ontouchstart = function (e) { e.preventDefault(); };
    };
    return CourseLearningMainComponent;
}());
export { CourseLearningMainComponent };



// WEBPACK FOOTER //
// ./src/app/course-learning-main/course-learning-main.component.ts.pre-build-optimizer.js